import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Typography,
    IconButton,
    Divider,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    LinearProgress
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { formatDate } from "../../../common/formatDate";
import { useAssetCalibrationHistoryGet } from "../stressEntry/stressEntryQueries";

interface Props {
    open: boolean;
    onClose: () => void;
    data?: any[];
    assetID: string;
    onUpdated:any;
}

export const CalibrationHistoryDialog = ({ open, onClose, assetID,onUpdated }: Props) => {

    const { isLoading: isaAssetHistoryLoading,
        isSuccess,
        isError,
        data, } = useAssetCalibrationHistoryGet(assetID);



   

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Calibration History</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Grid>
            </DialogTitle>

            <Divider />

            <DialogContent dividers>
                {isaAssetHistoryLoading ? <LinearProgress /> : (
                    <Paper>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Calibration Date</b></TableCell>
                                    <TableCell><b>Note</b></TableCell>
                                    <TableCell><b>Calibrated By</b></TableCell>
                                    <TableCell><b>Verified By</b></TableCell>
                                    <TableCell><b>Status</b></TableCell>

                                    <TableCell><b>Updated On</b></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {data.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            No calibration history found
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    data.map((row :any, i:any) => (
                                        <TableRow key={i}>
                                            <TableCell>
                                                {row.calibration_date
                                                    ? formatDate(row.calibration_date)
                                                    : "N/A"}
                                            </TableCell>
                                            <TableCell>{row.note || "N/A"}</TableCell>
                                            <TableCell>{row.calibrated_by || "N/A"}</TableCell>
                                            <TableCell>{row.verified_by || "N/A"}</TableCell>
                                            <TableCell>{row.status || "N/A"}</TableCell>
                                            <TableCell>
                                                {row.updated_on
                                                    ? formatDate(row.updated_on)
                                                    : "N/A"}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                )}

            </DialogContent>
        </Dialog>
    );
};
